export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 17.d49ac702.jpg";